import { fulfillmentOrderStatus } from 'common/constants';
import _ from 'lodash';
import isSome from './isSome';

export default function hasLabel(fulfillmentOrder) {
	return (
		_.findIndex(fulfillmentOrder.shipmentInfos, item => {
			return (
				(isSome(item.label) && item.shipmentInfoStatus.abrv == 'active') ||
				(fulfillmentOrder.fulfillmentOrderStatus.abrv == fulfillmentOrderStatus.shippedExternally ||
					fulfillmentOrder.fulfillmentOrderStatus.abrv == fulfillmentOrderStatus.exitScan)
			);
		}) != -1
	);
}



// WEBPACK FOOTER //
// ./src/core/utils/hasLabel.js